var React = require('react');

function VolumeOff (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 328V184a24 24 0 0 1 24-24h102.06l89-89c15-15 41-4.49 41 17v336c0 21.44-25.94 32-41 17l-89-88.95H24A24 24 0 0 1 0 328z","className":"fa-secondary","key":1})]);
}

VolumeOff.defaultProps = {"viewBox":"0 0 256 512","className":"icon"};

module.exports = VolumeOff;

VolumeOff.default = VolumeOff;
